export enum Routes {
  Home = '/',
  Login = '/login',
  User = '/user',
  Terms = '/terms',
  Privacy = '/privacy',
  Contact = '/contact',
  GetStarted = '/get-started',
}
